import { AppServerApiClient } from './AppServerApiClient';

let appApiClient: AppServerApiClient;

export function resetApi(apiUrl: string) {
    appApiClient = new AppServerApiClient(apiUrl);
}

export function getAppServerApiClient(): AppServerApiClient {
    if (!appApiClient) {
        appApiClient = new AppServerApiClient();
    }
    return appApiClient;
}
